import getSymbolFromCurrency from 'currency-symbol-map'
import React, {useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Form, Grid, Icon, Label, Loader, Message } from 'semantic-ui-react'
import { addItemsTabWarnings, deleteItemsTabWarnings } from '../../../commonActions/serverErrorAction'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import InputField from '../../../commonComponents/formComponents/inputField'
import PopUpIcon from "../../../commonComponents/formComponents/PopUpIcon"
import {
  collapseLineItems, expandLineItems, removeInvoiceLineItem,
  saveInvoiceLineItemFeild, updateInvoiceLineItemFeild,saveShipmentFieldValue
} from '../../actions'
import { getValidationError as ValidationError } from '../../Helper'
import ErrorBoundary from '../errorboundry'
import MerchandiseLineItems from './MerchandiseLineItems'
import { INVOICE_NUMBER, CURRENCY_CODE,INCO_TERMS} from '../../Helper/formLabel'
import { convertDateToUTC, convertDateToUTCEpoch } from '../../../Helper/date'

function InvoiceItem(props) {
  const dispatch = useDispatch()
  const invoiceItemIndex = props.invoiceItemIndex
  const invoiceId = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].invoiceId
  )
  const invoiceNumber = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].invoiceNumber
  )
  const shipmentCurrency = useSelector(
    (state) => state.Shipment.shipmentCurrency
  )
  const invoiceTotal = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].invoiceTotal
  )
  const invoiceDate = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].invoiceDate
  )

  const deliveryZoneIndicator = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].deliveryZoneIndicator
  )

  const descriptionOfPlaceOfDelivery = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].descriptionOfPlaceOfDelivery
  )
  const incoTermsConditionsCode = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].incoTermsConditionsCode
  )
  const grassWeight = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].grassWeight
  )
  const netWeight = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].netWeight
  )

  const poNo = useSelector((state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].poNo)

  const totalItem = useSelector((state) => state.Shipment.totalItem)
  const currencyCodes = useSelector((state) => state.DropDownValues.currencyCodes)

  const incoterms = useSelector((state) => state.DropDownValues.incoterms)
  const totalInvoiceAmount = useSelector((state) => state.Shipment.totalInvoiceAmount)

  const box203DeliveryZoneIndicator = useSelector(
    (state) => state.DropDownValues.box203DeliveryZoneIndicator
  )

  const flagForMerchLineItems = useSelector(
    (state) => state.InvoicesReducer.invoices[props.invoiceItemIndex].flag || false
  )

  const getValidationError=(field, value, Level, onlyMandatoryCheck=false)=>ValidationError(field, value, Level, onlyMandatoryCheck,'',translate)

  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }

  const [isRemoving, setIsRemoving] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [activeAccordianIndex, setActiveAccordianIndex] = useState(true)

  const setActiveAccordian = useCallback(() => {
    setActiveAccordianIndex(!activeAccordianIndex)
  }, [activeAccordianIndex])

  const updateRemoveFlag = useCallback(() => {
    setIsRemoving(false)
  }, [isRemoving])

  const { totalInvoiceItems, isFormDisabled, translate, jobWheels } = props

  const getErrorMessage = useCallback((key,value,flag=false)=>{
    return getValidationError(key, value, 'itemsTab',flag) || []
  },[descriptionOfPlaceOfDelivery,deliveryZoneIndicator,incoTermsConditionsCode])

  const invoiceIndex =
    (invoiceItemIndex + 1).toString().length === 1
      ? `00${invoiceItemIndex + 1}`
      : (invoiceItemIndex + 1).toString().length === 2
      ? `0${invoiceItemIndex + 1}`
      : invoiceItemIndex + 1

  const expand = () =>dispatch(expandLineItems(invoiceItemIndex))
  

  const collapse = () => dispatch(collapseLineItems(invoiceItemIndex))
  useEffect(() => {
    if (!totalInvoiceAmount && shipmentCurrency) {
      dispatch(saveShipmentFieldValue('shipmentCurrency'))
    }
  }, [])
  return (
    <ErrorBoundary>
        <div className={'accordian-section tab-contentInvoice '}>
          <Message>
            <div className='title' onClick={() => {}}>
              <div className='stepNumber' onClick={() => setActiveAccordian()}>
                <Icon name={activeAccordianIndex ? `minus circle` : `plus circle`}></Icon>
                <span>
                  {`${translate('INVOICE', { ns: ['default', 'lineItem'] })}: ` + invoiceIndex}
                </span>
              </div>
              <div style={{ float: 'right' }}>
                <Button
                  basic
                  color='blue'
                  style={{ marginTop: '-3px', float: 'right', marginRight: '-3px' }}
                  id="expandCollapseAllLines"
                  className='btn-add-item'
                  onClick={() => {
                    setShowLoader(true)
                    flagForMerchLineItems === false && expand()
                    flagForMerchLineItems === true && collapse()
                    setShowLoader(false)
                  }}
                  disabled={isFormDisabled}
                >
                  {showLoader === false ? (
                    <span className={'expandAllSection'} style={{ cursor: 'pointer' }}>
                      {flagForMerchLineItems === true
                        ? translate('COLLAPSE_ALL_LINES', { ns: ['default', 'lineItem'] })
                        : translate('EXPAND_ALL_LINES', { ns: ['default', 'lineItem'] })}
                    </span>
                  ) : (
                    <span>
                      <Loader active inline size='mini' style={{ marginRight: '10px' }} />
                      {translate('LOADING', { ns: ['default', 'lineItem'] })}...
                    </span>
                  )}
                </Button>
              </div>
              {totalInvoiceItems > 1 && (
                <span>
                  {!isRemoving ? (
                    <Icon
                      id={`delete-${invoiceId}`}
                      name='trash alternate outline'
                      onClick={(value) => {
                        if (!window.confirm('Are you sure ? Remove Invoice' + invoiceIndex)) return
                        setIsRemoving(true)
                        dispatch(
                          removeInvoiceLineItem(
                            invoiceId,
                            invoiceTotal,
                            invoiceItemIndex,
                            updateRemoveFlag,
                            totalItem
                          )
                        )
                      }}
                      disabled={isFormDisabled}
                    />
                  ) : (
                    <span>
                      <Loader active inline size='mini' style={{ marginRight: '10px' }} />
                    </span>
                  )}
                </span>
              )}
              <div
                style={{
                  textTransform: 'uppercase',
                  marginTop: '-33px',
                  textAlign: 'center',
                  color: 'black',
                }}
              >
                <strong>{translate('INVOICE', { ns: ['header', 'lineItem'] })}</strong>
              </div>
            </div>

            {activeAccordianIndex && (
              <>
                <Form.Group className='float-container  mg-t-15' widths='equal'>
                  <Grid className='kn__grid' style={{ marginTop: '-7px', marginLeft: '6px' }}>
                    <Grid.Row>
                      <Grid.Column width='5' className='divFormFeild'>
                        <InputField
                          isLabel={false}
                          id={`invoiceNumber-${invoiceId}`}
                          type='text'
                          label={translate(INVOICE_NUMBER, { ns: ['default', 'lineItem'] })}
                          value={invoiceNumber}
                          className={'field-bg'}
                          errors={getValidationError('invoiceNumber', invoiceNumber, 'itemsTab')}
                          clearInput={false}
                          disabled={isFormDisabled}
                          onChange={(value) => {
                            dispatch(
                              updateInvoiceLineItemFeild(invoiceId, {'invoiceNumber': value})
                            )
                          }}
                          onBlur={(value) => {
                            dispatch(saveInvoiceLineItemFeild(invoiceId, 'invoiceNumber'))
                            let err = getValidationError('invoiceNumber', invoiceNumber, 'itemsTab')
                             err.length
                              ? addErrors(
                                  'itemsTab',
                                  `invoice -00${invoiceItemIndex + 1}`+ ' :: ' +err[0]  ,
                                  `invoiceNumber-${invoiceId}`
                                )
                              : deleteErrors('itemsTab', '', `invoiceNumber-${invoiceId}`)
                          }}
                        />
                      </Grid.Column>
                      <Grid.Column width='5' className='divFormFeild datepicker1  ' style={{}}>
                        <InputField
                          isLabel={false}
                          id={`invoiceDate-${invoiceId}`}
                          type='date'
                          label={translate('INVOICE_DATE', { ns: ['default', 'lineItem'] })}
                          className='field-bg'
                          value={convertDateToUTC(invoiceDate?.epochs)}  
                          clearInput={false}
                          disabled={isFormDisabled}
                          onChange={(value) => {
                            value=convertDateToUTCEpoch(value)
                            dispatch(updateInvoiceLineItemFeild(invoiceId, {'invoiceDate': { epochs: value}}))
                            dispatch(saveInvoiceLineItemFeild(invoiceId,'invoiceDate',{ epochs: value}))
                          }}
                        />
                      </Grid.Column>
                      <Grid.Column width='6' className='divFormFeild'>
                        <InputField
                          isLabel={false}
                          id={`poNo-${invoiceId}`}
                          type='text'
                          label={translate('PO_NUM', { ns: ['default', 'lineItem'] })}
                          value={poNo}
                          // className={'field-bg'}
                          className='field-bg dropdown100'
                          clearInput={false}
                          disabled={isFormDisabled}
                          onChange={(value) => {
                            dispatch(updateInvoiceLineItemFeild(invoiceId, {'poNo': value}))
                          }}
                          onBlur={(value) => {
                            dispatch(saveInvoiceLineItemFeild(invoiceId, 'poNo'))
                          }}
                        />
                      </Grid.Column>
                      
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width='5' className='divFormFeild kg b-rw-0  border-bottom'>
                        <InputField
                          isLabel={false}
                          id={`grassWeight-${invoiceId}`}
                          type='text'
                          label={translate('GROSS_WEIGHT', { ns: ['default', 'lineItem'] })}
                          value={grassWeight}
                          className={'field-bg'}
                          clearInput={false}
                          disabled={true}
                          onChange={(value) => {
                            dispatch(
                              updateInvoiceLineItemFeild(invoiceId, {'grassWeight': value})
                            )
                          }}
                          onBlur={(value) => {
                            dispatch(saveInvoiceLineItemFeild(invoiceId, 'grassWeight'))
                          }}
                        />
                      </Grid.Column>

                      <Grid.Column width='5' className='divFormFeild kg b-rw-0  border-bottom'>
                        <InputField
                          isLabel={false}
                          id={`netMass-${invoiceId}`}
                          type='text'
                          label={translate('NET_MASS', { ns: ['default', 'lineItem'] })}
                          value={netWeight}
                          className={'field-bg'}
                          clearInput={false}
                          disabled={true}
                          onChange={(value) => {
                            dispatch(
                              updateInvoiceLineItemFeild(invoiceId, {'netWeight': value})
                            )
                          }}
                          onBlur={(value) => {
                            // dispatch(
                            //   updateInvoiceLineItemFeild(invoiceId, {'netWeight': value})
                            // )
                            dispatch(saveInvoiceLineItemFeild(invoiceId, 'netWeight'))
                          }}
                        />
                      </Grid.Column>

                      <Grid.Column width='6' className='divFormFeild border-bottom'>
                        <InputField
                          isLabel={false}
                          id={`invoiceAmount-${invoiceId}`}
                          type='text'
                          label={translate('INVOICE_AMOUNT', { ns: ['default', 'lineItem'] })}
                          value={invoiceTotal === '-999' ? '' : invoiceTotal}
                          className={'field-bg'}
                          clearInput={true}
                          errors={getValidationError('invoiceTotal', invoiceTotal, 'itemsTab')}
                          string={shipmentCurrency ? getSymbolFromCurrency(shipmentCurrency): getSymbolFromCurrency("EUR")}
                          addThousandsSeperator={true}
                          disabled={true}
                          onChange={(value) => {
                            dispatch(updateInvoiceLineItemFeild(invoiceId, { invoiceTotal: value }))
                          }}
                          onBlur={(value) => {
                            dispatch(
                              updateInvoiceLineItemFeild(
                                invoiceItemIndex,
                                {'invoiceTotal':
                                value === '' ? '-999' : parseFloat(value).toFixed(2)
                              })
                            )
                            let err = getValidationError('invoiceTotal', invoiceTotal, 'itemsTab')
                             err.length
                              ? addErrors(
                                  'itemsTab',
                                  `invoice -00${invoiceItemIndex + 1}`+ ' :: ' +err[0]  ,
                                  `invoiceTotal-${invoiceId}`
                                )
                              : deleteErrors('itemsTab', '', `invoiceTotal-${invoiceId}`)
                            dispatch(saveInvoiceLineItemFeild(invoiceId, 'invoiceTotal'))
                          }}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className='theme-textbox border-b-0' style={{ alignItems: 'center' }}>
                      <label className='label-address' style={{ marginLeft: '-5px' }}>
                        {' '}
                        {translate('TRADE_TERMS', { ns: ['default', 'lineItem'] })}
                      </label>

                      <Grid.Column width='6'>
                        <Grid.Row width='3'>
                          <Grid.Column width='3'>
                            <Label className='disabled title' style={{ marginLeft: '5px' }}
                            >
                              
                                {
                                getErrorMessage("incoTermsConditionsCode",incoTermsConditionsCode,true)?.length>0
                               
                                
                           &&
                            <PopUpIcon 
                            className="errorIcon"
                            color="red" icon="exclamation triangle circle"
                            popupText={getValidationError('incoTermsConditionsCode', incoTermsConditionsCode, 'itemsTab',true)[0]}
                           />
                        }
                           

                              {translate(INCO_TERMS, { ns: ['default', 'lineItem'] })}
                            </Label>

                          </Grid.Column>
                          <DropDown
                            id={`incoTermsConditionsCode-${invoiceId}`}
                            className='field-bg dropdown100 theme-dropdown'
                            labelClass='text-none'
                            style={{ marginLeft: '10px' }}
                            disabled={isFormDisabled}
                            isLabel={false}
                            data={incoterms}
                            value={incoTermsConditionsCode}
                            onChange={(value) => {
                              dispatch(
                                updateInvoiceLineItemFeild(
                                  invoiceId,
                                  {'incoTermsConditionsCode':
                                  value
                                })
                              )
                              dispatch(
                                saveInvoiceLineItemFeild(
                                  invoiceId,
                                  'incoTermsConditionsCode'
                                )
                              )
                              let err = getValidationError(
                                'incoTermsConditionsCode',
                                value,
                                'itemsTab',
                                true
                              )
                              err.length
                                ? addErrors(
                                    'itemsTab',
                                    `invoice -00${invoiceItemIndex + 1}` + ' :: ' + err[0],
                                    `incoTermsConditionsCode-${invoiceId}`
                                  )
                                : deleteErrors(
                                    'itemsTab',
                                    '',
                                    `incoTermsConditionsCode-${invoiceId}`
                                  )
                            }}
                          />
                        </Grid.Row>
                      </Grid.Column>
                      <Grid.Column width='4'>
                        <Grid.Row>
                          <Grid.Column width='3'>
                            <Label className='disabled title'>
                              {translate('LOCATION', { ns: ['default', 'lineItem'] })}

                              {getErrorMessage("descriptionOfPlaceOfDelivery",descriptionOfPlaceOfDelivery,false)?.length>0
                               &&
                               <PopUpIcon 
                               className="errorIcon"
                               color="red" icon="exclamation triangle circle"
                               popupText={getValidationError('descriptionOfPlaceOfDelivery', descriptionOfPlaceOfDelivery, 'itemsTab')[0]}
                              />
                           }

                              
                            </Label>
                          </Grid.Column>
                          <InputField
                            isLabel={false}
                            id={`descriptionOfPlaceOfDelivery-${invoiceId}`}
                            type='text'
                            value={descriptionOfPlaceOfDelivery}
                            className={'field-bg'}
                            clearInput={false}
                            disabled={isFormDisabled}
                            onChange={(value) => {
                              dispatch(
                                updateInvoiceLineItemFeild(
                                  invoiceId,
                                  {'descriptionOfPlaceOfDelivery':
                                  value}
                                )
                              )
                            }}
                            onBlur={(value) => {
                              dispatch(
                                saveInvoiceLineItemFeild(
                                  invoiceId,
                                  'descriptionOfPlaceOfDelivery'
                                )
                              )
                              let err = getValidationError('descriptionOfPlaceOfDelivery', descriptionOfPlaceOfDelivery, 'itemsTab')
                              err.length
                               ? addErrors(
                                   'itemsTab',
                                   `invoice -00${invoiceItemIndex + 1}`+ ' :: ' +err[0]  ,
                                   `descriptionOfPlaceOfDelivery-${invoiceId}`
                                 )
                               : deleteErrors('itemsTab', '', `descriptionOfPlaceOfDelivery-${invoiceId}`)
                            }}
                          />
                        </Grid.Row>
                      </Grid.Column>
                      <Grid.Column width='6'>
                        <Grid.Row>
                          <Grid.Column width='3'>
                            <Label className='disabled title'>
                              {translate('CODE', { ns: ['default', 'lineItem'] })}
                              { getErrorMessage ("deliveryZoneIndicator",deliveryZoneIndicator,true)?.length>0
                               &&
                               <PopUpIcon 
                               className="errorIcon"
                               color="red" icon="exclamation triangle circle"
                               popupText={getValidationError('deliveryZoneIndicator', deliveryZoneIndicator, 'itemsTab')[0]}
                              />
                           }
                            </Label>
                          </Grid.Column>
                          <DropDown
                            id={`deliveryZoneIndicator-${invoiceId}`}
                            className='field-bg dropdown100 theme-dropdown'
                            labelClass='text-none'
                            disabled={isFormDisabled}
                            isLabel={false}
                            direction={'left'}
                            data={box203DeliveryZoneIndicator}
                            value={deliveryZoneIndicator}
                            onChange={(value) => {
                              dispatch(
                                updateInvoiceLineItemFeild(
                                  invoiceId,
                                  {'deliveryZoneIndicator':
                                  value}
                                )
                              )
                              dispatch(saveInvoiceLineItemFeild(invoiceId, 'deliveryZoneIndicator'))
                              let err = getValidationError(
                                'deliveryZoneIndicator',
                                value,
                                'itemsTab'
                              )
                              err.length
                                ? addErrors(
                                    'itemsTab',
                                    `invoice -00${invoiceItemIndex + 1}` + ' :: ' + err[0],
                                    `deliveryZoneIndicator-${invoiceId}`
                                  )
                                : deleteErrors('itemsTab', '', `deliveryZoneIndicator-${invoiceId}`)
                            
                            }}
                          />
                        </Grid.Row>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form.Group>

                <MerchandiseLineItems
                  key={'merchandise-InvoiceItem' + invoiceId}
                  invoiceItemIndex={invoiceItemIndex}
                  invoiceIndex={invoiceIndex}
                  invoiceId={invoiceId}
                  expandAll={props.expandAll}
                  isFormDisabled={isFormDisabled}
                  translate={translate}
                  jobWheels={jobWheels}
                />
              </>
            )}
          </Message>
        </div>
    </ErrorBoundary>
  )
}

export default React.memo(InvoiceItem)
